
// Import Events Constatns
import {
  GET_EVENTS,
  GET_SINGLE_EVENT,
  EDIT_EVENT,
  GET_SIMILIAR_EVENTS,
  GET_COMPANIES,
  GET_CITIES,
  GET_PACKAGES,
  GET_EXPIRED_EVENTS,
  DELETE_EVENT
} from './constants'

// Get Single Event
export function getSingleEvent(id: string) {
  return {
    type: GET_SINGLE_EVENT,
    id
  }
}

// Edit, Create Event
export function editEvent(data: object) {
  return {
    type: EDIT_EVENT,
    data
  }
}

// Get Events
export function getAllEvents(category: string, page: number, search: string, admin?: boolean) {
  return {
    type: GET_EVENTS,
    category,
    page,
    search,
    admin,
  }
}

// Get Events
export function getExpiredEventsAction(category: string, page: number, search: string) {
  return {
    type: GET_EXPIRED_EVENTS,
    category,
    page,
    search
  }
}

// Get Similiar Events
export function getSimiliarEvents(category: string, unique_id: string, page: number) {
  return {
    type: GET_SIMILIAR_EVENTS,
    category,
    unique_id,  
    page
  }
}

// Get Companies
export function getCompaniesAction() {
  return {
    type: GET_COMPANIES
  }
}

//  Cities
export function getCitiesAction(city: string) { 
  return {
    type: GET_CITIES,
    city
  }
}

// Get Packages
export function getPackages() {
  return  {
    type: GET_PACKAGES
  }
}

export function deleteItem(id: string, page?: Number) {
  return {
    type: DELETE_EVENT,
    id,
    page
  }
}
